import {Nodes} from 'common/src/modules/nodes/nodes.types';
import {CardConnectionType} from '../cardsConnectionTool.enums';
import {ConnectionRequest} from '../cardsConnectionTool.types';
import wouldCreateLoop from './wouldCreateLoop';

/**
 * Collect issues for the connections
 * @param connections
 * @param campaignNodes
 * @returns
 */
export default function collectIssues(
  connections: ConnectionRequest[],
  campaignNodes: Nodes,
): string[] {
  const issues: string[] = [];

  // Process each connection
  for (const connection of connections) {
    const {sourceCardId, sourceCardOutputId, targetCardId, type} = connection;

    // Check if source card exists
    const sourceCard = campaignNodes[sourceCardId];

    if (!sourceCard) {
      issues.push(`Card id ${sourceCardId} doesn't exist`);
      continue;
    }

    // Check if target card exists (only for connect operations)
    if (type === CardConnectionType.Connect) {
      const targetCard = campaignNodes[targetCardId];

      if (!targetCard) {
        issues.push(`Card id ${targetCardId} doesn't exist`);
        continue;
      }
    }

    // Check if source card has the specified output
    const output = sourceCard.outputs?.find((out) => out.id === sourceCardOutputId);

    if (!output) {
      issues.push(`Card id ${sourceCardId} doesn't have output ${sourceCardOutputId}`);
      continue;
    }

    // For connect operations, check for loops
    if (type === CardConnectionType.Connect) {
      if (wouldCreateLoop(sourceCardId, targetCardId, campaignNodes)) {
        issues.push(
          `Cannot connect card ${sourceCardId} output ${sourceCardOutputId} to card ${targetCardId} because it creates an infinite loop`,
        );
        continue;
      }
    }
  }

  return issues;
}
